/// <amd-module name="Test/ManageTestPlans/Components/NewTestPlanFormValidators" />
import { INode, IValidationResult } from "Test/ManageTestPlans/NewTestPlanPageContracts";
import * as Resources from "Test/ManageTestPlans/Resources";

export class NewTestPlanFormValidators {
    public static validateName(name: string): IValidationResult {
        if (!name.trim()) {
            return {
                isValid: false,
                errorMessage: Resources.RequiredFieldErrorMessage
            };
        }

        return { isValid: true };
    }

    public static validateNodeValue(selectedPath: string, selectedNode: INode) {
        if (!selectedPath) {
            return {
                isValid: false,
                errorMessage: Resources.RequiredFieldErrorMessage
            };
        }

        if (!selectedNode) {
            return {
                isValid: false,
                errorMessage: Resources.InvalidPathErrorMessage
            };
        }

        return { isValid: true };
    }
}
